import { action, makeObservable, observable } from 'mobx';

class LoadingStore {
  progress = 0;

  isGameResourceLoaded = false;

  isTranslationsLoaded = false;

  hasGameInitialState = false;

  hasJackpotInitialState = false;

  isAllResourceLoaded = false;

  constructor() {
    makeObservable(this, {
      progress: observable,
      isGameResourceLoaded: observable,
      isTranslationsLoaded: observable,
      hasGameInitialState: observable,
      isAllResourceLoaded: observable,
      hasJackpotInitialState: observable,
      setProgress: action.bound,
      simulateProgress: action.bound,
      setIsAllResourceLoaded: action.bound,
      setHasGameInitialState: action.bound,
      setIsGameResourceLoaded: action.bound,
      setIsTranslationsLoaded: action.bound,
      setHasJackpotInitialState: action.bound,
    });
  }

  setIsAllResourceLoaded(bool) {
    this.isAllResourceLoaded = bool;
  }

  async simulateProgress(newValue) {
    if (typeof newValue !== 'number' || newValue < this.progress) {
      throw new Error('Invalid newValue');
    }

    const updateProgressWithDelay = (currentValue) => {
      if (currentValue > newValue) return null;

      this.updateProgress(currentValue);
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(updateProgressWithDelay(currentValue + 1));
        }, 20);
      });
    };

    await updateProgressWithDelay(this.progress);
  }

  updateProgress(newValue) {
    this.setProgress(newValue);
    this.setIsAllResourceLoaded(Math.ceil(this.progress) === 100);
  }

  setProgress(progressValue) {
    this.progress = progressValue;
  }

  setIsGameResourceLoaded(bool) {
    this.isGameResourceLoaded = bool;
  }

  setIsTranslationsLoaded(bool) {
    this.simulateProgress(90);
    this.isTranslationsLoaded = bool;
  }

  setHasGameInitialState(bool) {
    this.simulateProgress(100);
    this.hasGameInitialState = bool;
  }

  setHasJackpotInitialState(bool) {
    this.hasJackpotInitialState = bool;
  }

  calculateProgress(arr) {
    return arr.reduce((acc, curr, _, self) => acc + (Number(curr) / self.length) * 100, 0);
  }
}

export const loadingStore = new LoadingStore();
